// src/pages/Contact.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../components/ContactForm/ContactForm.tsx';
//import FAQ from '../components/FAQ/FAQ.tsx';
//import BookingJourney from '../components/BookingJourney/BookingJourney.tsx';
//import './Contact.css';

const Contact: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Contact Astrologer Kavitha Nandy | Book a Vedic Astrology Reading | Cosmic Kavi</title>
        <meta name="description" content="Get in touch with Astrologer Kavitha Nandy. Book a kundali reading, jyotish consultation, or Vaastu Shastra session. Remote services across the USA. Email or WhatsApp today." />
        <link rel="canonical" href="https://cosmickavi.com/contact" />
      </Helmet>
      {/* <section className="page-header">
        <div className="container">
          <h1>Connect with the Cosmos</h1>
          <p>Ready to unlock your cosmic potential? Let's begin your astrological journey together</p>
        </div>
      </section> */}
      <ContactForm />
      {/* <FAQ />
      <BookingJourney /> */}
    </>
  );
};

export default Contact;